import React from "react";
import Button from "../general/Button/Button";
import "./ShowcaseCard.css";

const ShowcaseCard = ({
  name,
  preview,
  type,
  description,
  category,
  onOpenSpecs,
}) => {

  const isVideo =
    type === "video" || (preview && preview.toLowerCase().endsWith(".mp4"));

  return (
    <article className="showcase-card-container">
      {preview && (
        <div className="showcase-card-preview">
          {isVideo ? (
            <video
              src={preview}
              muted
              loop
              autoPlay
              playsInline
              preload="metadata"
            />
          ) : (
            <img src={preview} alt={name} />
          )}
          {category && (
            <span className="showcase-card-badge">{category}</span>
          )}
        </div>
      )}

      <h3 className="showcase-card-title">{name}</h3>
      <p className="showcase-card-description">{description}</p>

      <Button variant="primary" fullWidth onClick={onOpenSpecs}>
        View Full Specs
      </Button>
    </article>
  );
};

export default ShowcaseCard;
